import { render } from "./TheHeader.vue?vue&type=template&id=b35f58b0&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=b35f58b0&scoped=true&lang=css"

import exportComponent from "C:\\Data\\lightsOut\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35f58b0"]])

export default __exports__